import React from "react";

const SvgView = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <path d="M8 5.5c-1.04 0-2.487.799-4.252 2.53C5.513 9.76 6.96 10.558 8 10.558c1.04 0 2.487-.799 4.252-2.53C10.487 6.3 9.04 5.5 8 5.5zm6.032 3.576C11.769 11.398 9.758 12.56 8 12.56s-3.769-1.161-6.032-3.483a1.5 1.5 0 0 1 0-2.094C4.231 4.661 6.242 3.5 8 3.5s3.769 1.16 6.032 3.482a1.5 1.5 0 0 1 0 2.094zM8 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
  </svg>
);

export default SvgView;
